const API_BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL || 'http://localhost:8080';
const WEBSOCKET_BASE_URL = process.env.REACT_APP_WEBSOCKET_BASE_URL || 'http://localhost:8080/ws';

export const config = {
    api: {
        baseUrl: API_BASE_URL,
        auth: {
            googleVerify: `${API_BASE_URL}/api/auth/google/verify`,
        },
        public: {
            proofs: `${API_BASE_URL}/api/public/proofs`,
        }
        // ... другие эндпоинты можно структурировать здесь
    },
    websocket: {
        url: WEBSOCKET_BASE_URL,
    },
    // Можно добавить и другие глобальные настройки сюда
    // например, ключи для внешних сервисов (если они не секретные)
};
export const SUPPORT_LINKS = {
        discord: 'https://discord.gg/rn9nVSuqXz',
        telegram: 'https://t.me/+h8bFGTaYa5wyMTc6',
        youtube: 'https://www.youtube.com/@aizer_play'
};

export default config; // Экспортируем по умолчанию для удобства